import React from 'react';
import { createPortal } from 'react-dom';
import { observer } from 'mobx-react-lite';
import { ComplianceConfigAuditContent } from 'src/components/ComplianceAudit/ComplianceAudit';

interface SourceOfFundsConfigAuditPropsType {
    onClose: () => void;
}

export const SourceOfFundsConfigAudit = observer(
    ({ onClose }: SourceOfFundsConfigAuditPropsType): JSX.Element =>
        createPortal(
            <div
                className='audits visible'
                data-test='source-of-funds-config-audit'
            >
                <div className='audits-content'>
                    <button
                        className='audits-minimize'
                        data-test='source-of-funds-config-audit-close'
                        onClick={onClose}
                        type='button'
                    />
                    <ComplianceConfigAuditContent feature='SourceOfFunds' />
                </div>
            </div>,
            document.body
        )
);
